import { ReactElement } from 'react';
import { NavLink } from '@localstack/ui';
import { buildRoute } from '@localstack/services';

import { DMSRoutes } from '../types';

interface Props {
  routes: DMSRoutes;
}

export const MainTabs = ({ routes }: Props): ReactElement => (
  <>
    <NavLink to={buildRoute(routes.RESOURCES_DMS_REPLICATION_INSTANCES)}>Replication Instances</NavLink>
    <NavLink to={buildRoute(routes.RESOURCES_DMS_ENDPOINTS)}>Endpoints</NavLink>
    <NavLink to={buildRoute(routes.RESOURCES_DMS_REPLICATION_TASKS)}>Replication Tasks</NavLink>
  </>
);
